<template>
  <teleport to="body">
    <div
      v-if="showBookInstructions"
      class="fixed top-0 left-0 w-full h-full"
    >
      <div>
        <div
          ref="bookInstructions"
          class="w-270 absolute z-100 shadow px-20 pt-15 pb-10 rounded-10 text-app-color transition-left-300"
          :class="[bookInstructionsClasses, {'border-3 border-link-color left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2': isMobile}]"
          :style="!isMobile ? `left: ${left}px; top: ${top}px` : '' "
        >
          <h3 class="text-19">Welcome {{ user.profile.firstName }},</h3>
          <p v-if="!isTeamAccount" class="text-14">
            This is the spaces page. You can create a space for any project or subject. We already created a <span class="font-bold">sample space</span> for you to discover.
          </p>
          <p v-else class="text-14">
            This is the spaces page. You can create a space for any
            <span class="font-bold">project</span> or
            <span class="font-bold">team</span>.
            We have already added some <span class="font-bold">sample spaces</span> for you to discover.
          </p>

          <div class="flex justify-end">
            <ButtonModule
              text="Got it"
              class="rounded-4 bg-link-color hover:bg-transparent px-30 py-10 text-white hover:text-link-color border-2 border-link-color text-14 mt-15 font-semibold"
              @click="acceptBooksInstruction"
            />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { profileService } from '@/services'

export default {
  components: { ButtonModule },

  data () {
    return {
      timer: null,
      left: -400,
      top: 0
    }
  },

  computed: {
    ...mapState({
      innerWidth: state => state.general.innerWidth,
      user: state => state.profile.user
    }),

    ...mapGetters(['isDarkMode', 'isMobile', 'isTeamAccount', 'isBookInstructionAccepted']),

    isBooksPage () {
      return this.$route.name === 'Books' || this.$route.name === 'TeamBooks'
    },

    bookInstructionsClasses () {
      const desktopClasses = this.isDarkMode ? 'bg-sidebar books-instruction-dark-theme' : 'bg-white books-instruction-origin-theme'
      const mobileClasses = this.isDarkMode ? 'bg-sidebar' : 'bg-white'
      return this.isMobile ? mobileClasses : desktopClasses
    },

    showBookInstructions () {
      return !this.isBookInstructionAccepted && this.isBooksPage
    }
  },

  watch: {
    innerWidth () {
      if (this.showBookInstructions) {
        this.position()
      }
    },

    showBookInstructions () {
      this.position()
    }
  },

  created () {
    this.$nextTick(() => {
      if (this.showBookInstructions) {
        this.position()
      }
    })
  },

  methods: {
    ...mapMutations(['setBookInstruction', 'loading', 'setNotification']),

    ...mapActions(['getProfile']),

    position () {
      setTimeout(() => {
        const firstBookRect = document.getElementById('books-container').children[0].children[0].getBoundingClientRect()
        const bookInstructionsRect = this.$refs.bookInstructions?.getBoundingClientRect() || {}

        // left
        this.left = firstBookRect.left - bookInstructionsRect.width - 20

        // top
        this.top = Math.floor(firstBookRect.top)
      }, 100)
    },

    async acceptBooksInstruction () {
      try {
        this.loading(true)
        const payload = {
          email: this.user.email,
          firstName: this.user.profile.firstName,
          lastName: this.user.profile.lastName,
          showBookOnboarding: true
        }
        await profileService.update(payload)
        await this.getProfile()
      } catch ({ data }) {
        this.setNotification({
          isVisible: true,
          message: data.error.message,
          color: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .books-instruction-origin-theme {
    @extend %instruction-origin-theme-arrow-right;
    &:before {
      @apply top-1/2 transform -translate-y-1/2;
      right: -39px;
    }
  }

  .books-instruction-dark-theme {
    @extend %instruction-dark-theme-arrow-right;
    &:before {
      @apply top-1/2 transform -translate-y-1/2;
      right: -39px;
    }
  }
</style>
